import Spin from "zq-ui-v3/components/Spin/Spin";
import * as React from "react";
import View from "zq-ui-v3/components/View/View";

const LoadPage: React.FC = () => {
  return (
    <View className="w-100 h-100 con-center flex-column">
      <Spin />
    </View>
  );
};
export default LoadPage;
